import { IInterceptorIO, TInfoIO } from '../../../core/interceptor';
import { ResponseAPI } from '../../../adapters/api';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

type t_field = '__all__' | string;
type t_error_message = string;

export interface IHTTPErrorMessage {
  message: t_error_message;
  field: t_field;
}

export type ErrorsAPI = Record<t_field, t_error_message[]>;
export type ExternalErrorsAPI =
  | t_error_message
  | t_error_message[]
  | IHTTPErrorMessage[]
  | Record<t_field, t_error_message>
  | Record<t_field, t_error_message[]>
  | Record<t_field, IHTTPErrorMessage>
  | Record<t_field, IHTTPErrorMessage[]>;

const lens = {
  errors: f1.lens('/packet/metadata/errors')
};

export class APIResponseMetadataErrors implements IInterceptorIO<ResponseAPI> {
  readonly id = 'api-metadata_errors';
  readonly type = 'response';

  async transform(infoIO: TInfoIO<ResponseAPI>) {
    const errors = f1.read(lens.errors, {} as ExternalErrorsAPI, infoIO);
    const errorsDictionary = this.conformErrors(errors);

    f1.write(lens.errors, errorsDictionary, infoIO);
    return infoIO;
  }

  conformErrors(errors: ExternalErrorsAPI): ErrorsAPI {
    const isArray = f1.is.array(errors);
    const errorsStore: any = errors;
    const errorsDictionary: ErrorsAPI = {};

    // pre-condition: four combinations (only dictionary)
    for (const field in errorsStore) {
      const error = errors[field];
      const errorList = f1.is.array(error) ? error : [error];

      for (const errorField in errorList) {
        const _error = errorList[errorField] as Record<t_field, t_error_message>;
        const hasField = _error['field'] != null;
        const assignField = hasField ? _error['field'] : !isArray ? field : '__all__';

        const assignValue = hasField ? _error['message'] : _error;

        (errorsDictionary[assignField] as any) = [...(errorsDictionary[assignField] || []), assignValue];
      }
    }

    // pre-condition: the value is always an array
    for (const k in errorsDictionary) {
      errorsDictionary[k] = f1.map((value: t_error_message | IHTTPErrorMessage) => {
        return f1.is.string(value) ? value : f1.is.record(value) ? `${value.message}` : `Unspecified issue(s)`;
      }, errorsDictionary[k] as unknown[]);
    }

    return errorsDictionary;
  }
}
